import React, { useState } from 'react'

import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Divider,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import CloseIcon from '@mui/icons-material/Close'

import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'
import Locale from 'react-phone-number-input/locale/pt-BR.json'

import "./styles.css"

export default function AddScoutForm({ open, handleClose, submit, users }) {

    const [name, setName] = useState();
    const [number, setNumber] = useState();
    const [email, setEmail] = useState();
    const [createdBy, setCreatedBy] = useState('');

    return (
        <div>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle className="group-flexbox">
                    Adicionar Conta Scout
                    <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose}>
                        <CloseIcon />
                    </Button>
                </DialogTitle>
                <Divider />
                <DialogContent className="add-bot-dialog-content">
                    <TextField
                        size="small"
                        label="Nome"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <Box className="phone-input-container">
                        <PhoneInput
                            defaultCountry="BR"
                            locale={Locale.BR}
                            placeholder="Número de telefone"
                            limitMaxLength
                            value={number}
                            onChange={setNumber}
                        />
                    </Box>
                    <TextField
                        size="small"
                        label="Email"
                        fullWidth
                        type="email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <FormControl fullWidth size="small">
                        <InputLabel id="notification-opt-out-label">Dono</InputLabel>
                        <Select
                            labelId="notification-opt-out-label"
                            value={createdBy}
                            label="Dono"
                            onChange={({target}) => setCreatedBy(target.value)}
                        >
                            {users.map((item) => (
                                <MenuItem id={`user-item-${item.id}`} value={item.id}>{item.first_name} {item.last_name} - {item.username}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box className="user-footer">
                        <LoadingButton className="button-created" onClick={handleClose}>
                            Cancelar
                        </LoadingButton>
                        <LoadingButton className="button-created"
                            onClick={() => submit(name, number.replace('+', ''), email, createdBy)}
                            disabled={!name || !number || !email || !createdBy}
                        >
                            Salvar
                        </LoadingButton>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
}
